import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SaleRefundCardConfirmationComponent } from './sale-refund-card-confirmation.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    SharedModule   
  ],
  declarations: [SaleRefundCardConfirmationComponent],
  exports: [SaleRefundCardConfirmationComponent]
})
export class SaleRefundCardConfirmationComponentModule {}